import type { VoucherApi } from './vouchers/types'

export const AmountTypeApiValues = {
  FULL: 'Full',
  PARTIAL: 'Partial',
  MIN_DEPOSIT: 'MinDeposit',
  CUSTOM_PARTIAL: 'CustomPartial',
} as const

export type AmountTypeApi = (typeof AmountTypeApiValues)[keyof typeof AmountTypeApiValues]

export const TransactionTypeApiValues = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  VOUCHER: 'voucher',
} as const

export type TransactionTypeApi = (typeof TransactionTypeApiValues)[keyof typeof TransactionTypeApiValues]

export interface MoneyPriceApi {
  currency: CurrencyApi
  amount: number
}

export interface CurrencyApi {
  code: string
  symbol: string
  id: number
}

export interface AmountOptionApi {
  type: AmountTypeApi
  currency: CurrencyApi
  amount: number
  availablePaymentMethodTypes: string[]
  amountsWithFees?: AmountWithFee[]
}

export interface AmountWithFee {
  paymentMethodType: string
  amount: number
  currency: CurrencyApi
}

export interface PartialPaymentApi {
  maximumPartialAmount: MoneyPriceApi
}

export interface PaymentOptionsApi {
  paymentProvider: string
  amountOptions: AmountOptionApi[]
  paymentMethods: PaymentMethodApi[]
  amountMoneyAlreadyPaid?: MoneyPriceApi
  partialPayment?: PartialPaymentApi
  downPaymentAlreadyCovered: boolean
  nextPayments?: NextPaymentsApi
  availableVouchers?: VoucherApi[]
}

export interface NextPaymentsApi {
  fullPayment: NextPaymentApi
  downPayment: NextPaymentApi
}

export interface NextPaymentApi {
  dueDate: string
}

export interface PaymentMethodApi {
  paymentMethodType: string
  transactionType: TransactionTypeApi
  groupCode: string
  percentageFee?: number
  fixedFee?: number
}

export interface AdyenCheckoutConfig {
  [key: string]: unknown
}

export interface CreatePaymentParametersRequest {
  bookingNumber: string
  paymentmethod: string
  paymentoption: string
  fullPaymentAmount: number | null
  downPaymentAmount: number | null
  partialPaymentAmount: number | null
  groupUserId: string | null
  contextitemid: string
  referrerUrl: string
}

export interface InitPaymentRequest {
  bookingNumber: string
  paymentMethodBrand: string
  paymentOption: string
  fullPaymentAmount: number | null
  downPaymentAmount: number | null
  partialPaymentAmount: number | null
  groupUserId: string | null
  contextitemid: string
  referrerUrl: string
  adyenPaymentObject: string
}

export interface SubmitAdditionalDetailsRequest {
  adyenAdditionalDetails: string
  bookingIdentifier: string
  channel: string
}

export interface AdyenPaymentAction {
  [key: string]: unknown
}

export interface AdyenPaymentResponse {
  action?: AdyenPaymentAction
  resultCode?: string
  refusalReason?: string
  refusalReasonCode?: string
  pspReference?: string
  merchantReference?: string
  additionalData?: {
    pspReference?: string
    merchantReference?: string
  }
}

export interface CreatePaymentParametersResponse {
  adyen: AdyenCheckoutConfig
  successUrl?: string | null
}

export interface InitPaymentResponse {
  adyenPaymentResponse: AdyenPaymentResponse | string
}

export interface SubmitAdditionalDetailsResponse {
  adyenPaymentResponse: AdyenPaymentResponse | string
}
